<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import {useRoute} from "vue-router";
import $ from "jquery";

export default {
  name: "ProductsPage",
  components: {LoadingPage},
  setup() {

    let loading = ref(false)
    let sub_id = useRoute().params.sub_id
    let sub_name = ref(useRoute().params.sub_name)

    let products = ref([])



    function load_category() {

      loading.value = true
      FreeWorld.Heisenberg({}, 'shop/categories', true).then((res) => {

        loading.value = false

        if (sub_id != 0) {
          res.data.forEach(category => {
            category.subcategory.forEach(subcategory => {
              if (subcategory.id == sub_id) {
                products.value = subcategory.products
              }
            });
          });
        }else {
          let productsArray = res.data.reduce((accumulator, category) => {
            category.subcategory.forEach(subcategory => {
              accumulator.push(...subcategory.products);
            });
            return accumulator;
          }, []);

          let seen = new Set();
          let uniqueProducts = productsArray.filter(item => {
            if (seen.has(item.id)) {
              return false;
            } else {
              seen.add(item.id);
              return true;
            }
          });

          products.value = uniqueProducts;
        }

        if (products.value.length > 0) {
          setTimeout(() => {
            const products = document.querySelectorAll('.product');
            products.forEach(product => {
              product.classList.remove('animate__animated', 'animate__fadeInRight');
            });
          }, 1000)
        }

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, load_category)
      })

    }
    load_category()

    let pid
    function open_edit(id) {

      let bg_edit = document.getElementById('bg_edit')

      if (id !== 'close') {

        pid = id
        let div = document.getElementById('edit' + pid);
        if (div.style.width !== '33vw') {
          div.style.padding = '1rem'
          div.style.height = div.scrollHeight + 32 + 'px';
          div.style.width = '33vw'
          bg_edit.style.display = 'block'
        } else {
          div.style.padding = '0'
          div.style.height = '0px';
          div.style.width = '0px'
          bg_edit.style.display = 'none'
        }
      }else {

        let div = document.getElementById('edit' + pid);
        div.style.padding = '0'
        div.style.height = '0px';
        div.style.width = '0px'
        bg_edit.style.display = 'none'
      }
    }

    function delete_prod(id) {

      Swals.Question('آیا از حذف این محصول اطمینان دارید؟' , 'حذف محصول').then((res)=>{

        if (res.isConfirmed){

          loading.value = true
          FreeWorld.Heisenberg({pid:id} , 'shop/product_delete' , true).then((res)=>{

            loading.value = false
            if (res.data.status === 'ok'){
              Swals.Done('محصول مورد نظر با موفقیت حذف شد')
              open_edit('close')
              products.value.forEach((item, index) => {
                if (item.id === id) {
                  $("#product" + id).addClass('animate__animated animate__fadeOutRight');
                  setTimeout(() => {
                    products.value.splice(index, 1);
                  }, 500);
                }
              });
            }else {
              Swals.Fault('متاسفانه محصول مورد نظر حذف نشد!')
            }

          }).catch((res)=>{
            loading.value = false
            Swals.Catch(res , ()=>{delete_prod(id)})
          })

        }

      })

    }

    return {

      loading,
      products,
      open_edit,
      delete_prod,
      sub_name,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>
<div id="bg_edit" class="bg_edit" @click="open_edit('close')"></div>


  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="animate__animated animate__fadeIn font-color font-bold">{{ sub_name }}</p>
        <router-link :to="{name:'ProductsManagement'}">
          <img class="svg-arrow" src="../assets/img/arrow.svg" alt="">
        </router-link>
      </div>
    </div>
    <br>
    <br>
    <br>

    <div v-if="products.length !== 0" class="p-body mt-3 list_products">

      <div v-for="item in products" :key="item.id"
                  :id="'product' + item.id" class="animate__animated animate__fadeInRight product text-decoration-none bg-white mb-3 shadow-custom p-2 rounded-4 d-flex justify-content-between">
        <div class="w-60 ml-3 d-flex flex-column justify-content-around">
          <div class="overflow-hidden">
            <p class="font-bold font-5" :class="{'txtoverflow': item.name.length > 30}">{{ item.name }}</p>
          </div>

          <div class="overflow-hidden">
            <p v-if="item.brand !== null" class="font-5 my-2" :class="{'txtoverflow': item.brand.length > 20}">از برند {{ item.brand }}</p>
            <p v-else class="font-5 my-2">برند مشخص نشده</p>
          </div>

          <div class="d-flex align-items-center">
            <p class="font-5 d-flex font-color font-bold mr-3">
              <span class="">{{ item.price_off.toLocaleString() }}</span>
              <span class="mr-1">تومان</span>
            </p>
          </div>

          <div class="div_hr my-2"></div>

          <div class="d-flex align-items-center justify-content-between">

            <div class="d-flex align-items-center position-relative">
              <div :id="'edit' + item.id" class="div_edit animate__animated animate__fadeIn rounded-shaped shadow-custom bg-white position-absolute overflow-hidden">
                <router-link :to="{name:'AddProducts',params:{action:item.id}}" class="text-decoration-none text-black d-flex align-items-center">
                  <img class="ml-2 icon_edit" src="../assets/img/pencil_color.svg" alt="">
                  <p class="font-5">ویرایش</p>
                </router-link>

                <div class="div_hr my-3"></div>


                <div @click="delete_prod(item.id)" class="d-flex align-items-center">
                  <img class="ml-2 icon_edit" src="../assets/img/trash-bin_color.svg" alt="">
                  <p class="font-5">حذف</p>
                </div>
              </div>

              <img @click="open_edit(item.id)" class="icon_shop" src="../assets/img/edit_prod.svg" alt="">
            </div>

            <router-link :to="{name:'DetailsProducts',params:{pid:item.id}}" class="text-decoration-none text-black bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">مشاهده جزییات</router-link>
          </div>

        </div>

        <div class="img_prod rounded-3 animated-background">
          <img class="w-100 h-100 rounded-3" :src="item.pic" alt="">
        </div>
      </div>
      <div v-for="item in products" :key="item.id"
                  :id="'product' + item.id" class="animate__animated animate__fadeInRight product text-decoration-none bg-white mb-3 shadow-custom p-2 rounded-4 d-flex justify-content-between">
        <div class="w-60 ml-3 d-flex flex-column justify-content-around">
          <div class="overflow-hidden">
            <p class="font-bold font-5" :class="{'txtoverflow': item.name.length > 30}">{{ item.name }}</p>
          </div>

          <div class="overflow-hidden">
            <p v-if="item.brand !== null" class="font-5 my-2" :class="{'txtoverflow': item.brand.length > 20}">از برند {{ item.brand }}</p>
            <p v-else class="font-5 my-2">برند مشخص نشده</p>
          </div>

          <div class="d-flex align-items-center">
            <p class="font-5 d-flex font-color font-bold mr-3">
              <span class="">{{ item.price_off.toLocaleString() }}</span>
              <span class="mr-1">تومان</span>
            </p>
          </div>

          <div class="div_hr my-2"></div>

          <div class="d-flex align-items-center justify-content-between">

            <div class="d-flex align-items-center position-relative">
              <div :id="'edit' + item.id" class="div_edit animate__animated animate__fadeIn rounded-shaped shadow-custom bg-white position-absolute overflow-hidden">
                <router-link :to="{name:'AddProducts',params:{action:item.id}}" class="text-decoration-none text-black d-flex align-items-center">
                  <img class="ml-2 icon_edit" src="../assets/img/pencil_color.svg" alt="">
                  <p class="font-5">ویرایش</p>
                </router-link>

                <div class="div_hr my-3"></div>


                <div @click="delete_prod(item.id)" class="d-flex align-items-center">
                  <img class="ml-2 icon_edit" src="../assets/img/trash-bin_color.svg" alt="">
                  <p class="font-5">حذف</p>
                </div>
              </div>

              <img @click="open_edit(item.id)" class="icon_shop" src="../assets/img/edit_prod.svg" alt="">
            </div>

            <router-link :to="{name:'DetailsProducts',params:{pid:item.id}}" class="text-decoration-none text-black bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">مشاهده جزییات</router-link>
          </div>

        </div>

        <div class="img_prod rounded-3 animated-background">
          <img class="w-100 h-100 rounded-3" :src="item.pic" alt="">
        </div>
      </div>

      <br>
      <br>
      <br>

    </div>

<!--    <div v-else style="height: 55vh" class="d-flex w-100 animate__animated animate__fadeIn">-->
<!--      <div class="d-flex flex-column align-items-center justify-content-end">-->
<!--        <img src="../assets/img/product-not-found.png" class="mb-3 w-50" alt="">-->
<!--        <p class="font-3 font-bold">متاسفانه محصولی با این نام وجود ندارد!</p>-->
<!--      </div>-->
<!--    </div>-->


  </div>

</template>


<style scoped>

@media (min-width: 900px) {
  .img_prod {
    width: 26% !important;
    height: 12rem !important;
  }
}
.img_prod {
  width: 40%;
  height: 11.3rem;
}

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

.icon_shop {
  width: 27px;
}
.icon_edit{
  width: 15px;
}

.div_edit{
  width: 0px;
  height: 0px;
  top: 0;
  right: 30px;
  z-index: 6;
  transition: .5s;
}
.bg_edit{
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  max-width: 70rem;
  z-index: 5;
  display: none;
}

</style>